import React, { useState } from "react";
import "./Localization.scss";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Select, Space } from "antd";
import userApi from "services/UserApi";
import Helpers from "@utils/Helpers";
import { errorLog } from "logging";
import { useUser } from "contexts/UserContext";
import { useUnit } from "contexts/UnitContext";
import SearchSetting from "@components/SearchSetting/SearchSetting";
const { Option } = Select;

interface ILocalization {
  isUpdating: boolean;
  setIsUpdating: (is: boolean) => void;
}
const Localization: React.FC<ILocalization> = ({
  isUpdating,
  setIsUpdating,
}) => {
  const { setUnits } = useUnit();
  const { userProfile, updateUserProfile } = useUser();
  const [localizations, setLocalizations] = useState({
    currency: userProfile?.settings?.currency,
    language: userProfile?.settings?.language,
    length: userProfile?.settings?.length,
    distance: userProfile?.settings?.distance,
    weight: userProfile?.settings?.weight,
  });

  const handleSave = async () => {
    setIsUpdating(true);
    try {
      const response = await userApi.changeLocalization(localizations);
      if (response.status === 200) {
        handleSaveSuccess(
          response.data.data.access_token,
          response.data.data.refresh_token
        );
      }
    } catch (error: any) {
      setIsUpdating(false);
      Helpers.notification.error(
        "Cannot update currency and units. Please try again"
      );
      errorLog("Localization.tsx - handleSave", error);
    }
  };

  const handleSaveSuccess = (access: string, refresh: string) => {
    setIsUpdating(false);
    const userParsed = Helpers.decodeToken(access);
    setUnits(userParsed.user.settings);
    updateUserProfile(access, refresh);
    Helpers.showSuccessUpdated("Update currency and units successfully");
  };

  const handleChangeLocalization = (key: string, value: any) => {
    setLocalizations({ ...localizations, [key]: value });
  };

  return (
    <div className="Localization">
      <SearchSetting />
      <div className="page-title">Localization</div>

      <div className="setting-group">
        <div className="title">Currency and Language</div>
        <Row gutter={[20, 20]}>
          <Col span={12}>
            <div className="form-group">
              <div className="setting-title">Currency</div>
              <Select
                size="large"
                variant="filled"
                disabled
                value={localizations.currency}
                onChange={(value) =>
                  handleChangeLocalization("currency", value)
                }
              >
                <Select.Option value="CAD">CAD</Select.Option>
                <Select.Option value="USD">USD</Select.Option>
                <Select.Option value="EUR">EUR</Select.Option>
              </Select>
            </div>
          </Col>
          <Col span={12}>
            <div className="form-group">
              <div className="setting-title">Language</div>
              <Select
                size="large"
                variant="filled"
                value={localizations.language}
                onChange={(value) =>
                  handleChangeLocalization("language", value)
                }
              >
                <Option value="en">English (US)</Option>
                <Option value="fr">French (FR)</Option>
              </Select>
            </div>
          </Col>
        </Row>
      </div>

      <div className="setting-group">
        <div className="title">Measuring Units</div>
        <Row gutter={[20, 20]}>
          <Col span={12}>
            <div className="form-group">
              <div className="setting-title">Distance</div>
              <Select
                size="large"
                variant="filled"
                value={localizations.distance}
                onChange={(value) =>
                  handleChangeLocalization("distance", value)
                }
              >
                <Option value="km">Kilometer (km)</Option>
                <Option value="mile">Mile (in)</Option>
              </Select>
            </div>
          </Col>
          <Col span={12}>
            <div className="form-group">
              <div className="setting-title">Weight</div>
              <Select
                size="large"
                variant="filled"
                value={localizations.weight}
                onChange={(value) => handleChangeLocalization("weight", value)}
              >
                <Option value="lb">Pound (lb)</Option>
                <Option value="ton">Tons (tons | Imperial)</Option>
                <Option value="kg">Kilogram (kg)</Option>
              </Select>
            </div>
          </Col>
        </Row>
      </div>

      <div className="form-submit">
        <Button className="save-btn" disabled={isUpdating} onClick={handleSave}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default Localization;
